<template>
    <div class="sb-lounge-products-list" data-test="sb-lounge-products-list">
        <UiProductsSectionsLoungeProductsList v-editable="blok" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
import type { ILoungeProductsList } from '@nuxt-monorepo/ui/types/components/ProductSections/LoungeProductsList';

defineProps<{
    blok: ILoungeProductsList;
}>();
</script>

<style lang="postcss" scoped></style>
